export const VIEW_MODES = {
  DATE: 'DATE',
  STANDARDS: 'STANDARDS',
  INCOMPLETE_ASSIGNMENTS: 'INCOMPLETE_ASSIGNMENTS'
};
